import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body2 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-2xl',
          'text-xl',
          'text-gray-800',
          'font-normal',
          'leading-relaxed tracking-normal',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body2.displayName = 'Body2'

export default Body2
